"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TripleAttackAbilityHandler = exports.TripleAttackActorAbilityFactory = exports.TripleAttackAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const __1 = require("../..");
class TripleAttackAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.TripleAttack;
        this.__typeName = "TripleAttack";
    }
}
exports.TripleAttackAbilityArgs = TripleAttackAbilityArgs;
let TripleAttackActorAbilityFactory = class TripleAttackActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("TripleAttack", "Self", 0);
    }
};
TripleAttackActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("TripleAttack")
], TripleAttackActorAbilityFactory);
exports.TripleAttackActorAbilityFactory = TripleAttackActorAbilityFactory;
let TripleAttackAbilityHandler = class TripleAttackAbilityHandler {
    init(sequence, container, actorId) {
        container.applyEffect(sequence, actorId, actorId, new __1.EchoEffectArgs(1));
    }
    activate(sequence, container, ability) { }
};
TripleAttackAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.TripleAttack)
], TripleAttackAbilityHandler);
exports.TripleAttackAbilityHandler = TripleAttackAbilityHandler;
